import type * as Types from './types';

import {
  useQuery,
  type QueryClient,
  type UseQueryOptions,
  type UseQueryResult,
  type FetchQueryOptions,
} from '@tanstack/react-query';
import type { DXError } from '@dx-ui/types-graphql';

export const GetLanguageSelectorHotelDataDocument = {
  operationName: 'hotel',
  operationString: `query hotel($ctyhocn: String!) {
  hotel(ctyhocn: $ctyhocn, language: "en") {
    localization {
      languageSupport {
        label
        bookingUrl
        code
        siteUrl
      }
    }
  }
}`,
  originalOpName: 'getLanguageSelectorHotelData',
};

export function useGetLanguageSelectorHotelDataQuery<
  TData = Types.GetLanguageSelectorHotelDataQuery,
  TError = DXError,
>(
  variables: Types.GetLanguageSelectorHotelDataQueryVariables,
  options?: Omit<
    UseQueryOptions<Types.GetLanguageSelectorHotelDataQuery, TError, TData>,
    'queryKey'
  >
): UseQueryResult<TData, TError> {
  return useQuery<Types.GetLanguageSelectorHotelDataQuery, TError, TData>({
    queryKey: [GetLanguageSelectorHotelDataDocument, variables],
    ...options,
  });
}

export function serverSideGetLanguageSelectorHotelDataQuery(
  queryClient: QueryClient,
  variables: Types.GetLanguageSelectorHotelDataQueryVariables,
  options?: FetchQueryOptions<Types.GetLanguageSelectorHotelDataQuery>
) {
  return queryClient.fetchQuery<Types.GetLanguageSelectorHotelDataQuery>({
    queryKey: [GetLanguageSelectorHotelDataDocument, variables],
    ...options,
  });
}
